import type { UserPoliciesList } from "@keystone-ui/types";

import { useSelectedPolicy } from "data/ss-data-hooks";

import { useFlags } from "./feature-flags";

type PolicySummary = UserPoliciesList[number];

type FeatureMap = {
  [key: string]: (
    policy: PolicySummary,
    flags: { [key: string]: unknown },
  ) => boolean;
};

/**
 * Configure policy dependent features here.
 */
const policyFeatureMap: FeatureMap = {
  /**
   * Control visibility of SS1 banner, card, and badge
   */
  sageSureOneDisplay(policy, flags) {
    return (
      !!flags.sageSureOne &&
      (policy.sageSureOne?.level === "SELECT" ||
        policy.sageSureOne?.level === "RESERVE")
    );
  },
} as const;

/**
 * Policy feature hook centralizes policy-based configuration.
 *
 * ```
 * const showBanner = usePolicyFeature("sageSureOneDisplay")
 * ```
 */
export function usePolicyFeature(key: string, policyId?: string) {
  const flags = useFlags();
  const { data } = useSelectedPolicy(policyId);
  if (data && policyFeatureMap[key]) {
    return policyFeatureMap[key](data, flags);
  }
  return false;
}
